"use client";

import { doc } from "@firebase/firestore/lite";
import { Spin } from "antd/lib";
import { useRouter } from "next/navigation";
import { useEffect, useMemo, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import CompletedModalCustomGame from "../../../components/CompletedModalCustomGame";
import Game, { GameConfig, GameEvents } from "../../../components/game/Game";
import { Guess, Puzzle, State } from "../../../models/gameModels";
import { db, getDoc } from "../../../services/firebase";
import { stateFromPuzzle } from "../../../services/state";

interface CustomPuzzleParams {
  author: string;
  name: string;
  puzzle: Puzzle;
}
export default function Page({
  params,
}: {
  params: { id: string[] | undefined };
}) {
  const id = params?.id?.[0];
  const router = useRouter();
  if (!id) {
    router.push("/");
    return <h1>Page not found</h1>;
  }
  const [puzzle, setPuzzle] = useState<CustomPuzzleParams | undefined>(
    undefined,
  );
  useEffect(() => {
    getDoc(doc(db, "customPuzzles", id)).then((doc) => {
      if (doc.exists()) {
        setPuzzle(doc.data() as CustomPuzzleParams);
      } else {
        toast("Puzzle not found", { icon: "🧩" });
        setTimeout(() => router.push("/"), 5000);
      }
    });
  }, []);
  if (!puzzle) {
    return (
      <div
        style={{
          display: "flex",
          minHeight: "400px",
          width: "100%",
          height: "100%",
        }}
      >
        <Spin style={{ margin: "auto" }} />
      </div>
    );
  }
  return (
    <div>
      <Toaster />
      <div>
        <span
          style={{
            fontSize: "26px",
            color: "black",
          }}
        >
          {puzzle.name}
        </span>
        <br />
        <span
          style={{
            fontSize: "16px",
            color: "darkgray",
            fontStyle: "italic",
          }}
        >
          נוצר על ידי {puzzle.author}
        </span>
      </div>
      <div>
        <CustomPuzzleGame puzzle={puzzle} />
      </div>
    </div>
  );
}

const CustomPuzzleGame = ({ puzzle }: { puzzle: CustomPuzzleParams }) => {
  const [completedModalData, setCompletedModalData] = useState(
    null as State | null,
  );
  const [showModal, setShowModal] = useState(false);
  const state = useMemo(() => stateFromPuzzle(puzzle.puzzle), []);
  const events: GameEvents = useMemo(
    () => ({
      onGuess: function (_state: State, _guess?: Guess | undefined): void {},
      onWin: function (_state: State): void {},
      onLose: function (_state: State): void {},
      onStateChange: function (_state: State): void {},
      onShowModal: function (state: State): void {
        console.log({ asda: state });
        setCompletedModalData(state);
        setShowModal(true);
      },
    }),
    [],
  );
  const config: GameConfig = useMemo(
    () => ({
      showAdmin: false,
      showTimer: false,
    }),
    [],
  );
  console.log({ state });
  return (
    <>
      {completedModalData && (
        <CompletedModalCustomGame
          puzzleName={puzzle.name}
          isOpen={!!completedModalData && showModal}
          closeHandler={() => setShowModal(false)}
          finalState={completedModalData}
          puzzleUrl={`${document.location.href}`}
          author={puzzle.author}
        />
      )}
      <Game key={1} events={events} config={config} initState={state} />
    </>
  );
};
